import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }

import { PropType, computed } from 'vue'
import axios from 'axios'
import { FormMeta } from 'vee-validate'


export default /*#__PURE__*/_defineComponent({
  __name: 'GwApiErrors',
  props: {
  error: { default: null, required: false, type: [Object, String] },
  meta: { default: null, required: false, type: Object as PropType<FormMeta<Record<string, any>>> },
},
  setup(__props) {

const props = __props;



const errors = computed(() => {
  if (!props.error) return [] as string[][]
  if (typeof props.error === 'string') return [[props.error]]

  let errorResponse
  if (
    axios.isAxiosError(props.error) &&
    props.error.response &&
    (props.error.response.status === 422 || props.error.response.status === 401)
  ) errorResponse = props.error.response
  else errorResponse = props.error as any

  if (errorResponse) {
    const { data: { error } } = errorResponse
    if (typeof error === 'string') return [[error]]
    return Object.values(error) as string[][]
  }

  return [] as string[][]
})

return (_ctx: any,_cache: any) => {
  return (!__props.meta?.touched && errors.value.length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(errors.value, (errorItem, i) => {
          return (_openBlock(), _createElementBlock("div", {
            key: i,
            class: "gw-error"
          }, _toDisplayString(errorItem.join(" ")), 1))
        }), 128))
      ]))
    : _createCommentVNode("", true)
}
}

})